.container {
  display: flex;
  flex-direction: row;
  overflow: hidden;

  &[data-align='end'] {
    justify-content: flex-end;
  }

  &[data-full-width='true'] {
    width: 100%;
  }
}

.tags-container {
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
  min-width: 0;
  overflow: hidden;

  &[data-wrap='true'] {
    flex-wrap: wrap;
  }
}
